<template>
  <div class="tenant">
    <div class="head-box">
      <div class="c-flex c-flex-item">
        <h4>租户列表</h4>
        <span
          v-if="entity.agencyId"
          class="c_size_12 c_pointer c_m_l_n c_blue"
          @click="osg.doCopy(origin + '/Templates?aid=' + entity.agencyId)"
        >
          <i class="el-icon-document-copy"></i>
          点击复制模板市场渠道链接
        </span>
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入名称/手机/邮箱"
          v-model="searchValue"
          class="search-input"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="c-m-l-10" @click.native="doNew">添加租户</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无租户"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column
            prop="name"
            label="名称"
            width="150px"
            fixed="left"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="code" label="编号" width="150px"></el-table-column>
          <el-table-column prop="phone" label="手机" width="150px"></el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            width="180px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            width="180px"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="exts.userCount" label="用户数量"></el-table-column> -->
          <!-- <el-table-column prop="level" label="等级"></el-table-column>
          <el-table-column
            prop="vipState"
            label="状态"
            :formatter="formatterState"
          ></el-table-column>
          <el-table-column prop="vipType" label="类型" :formatter="formatterType"></el-table-column>
          <el-table-column prop="vipEndDate" label="会员截止日期" width="140px"></el-table-column>
          <el-table-column
            prop="vipMaxUserCout"
            label="会员最大用户数"
            width="120px"
          ></el-table-column>
          <el-table-column
            prop="vipMaxWorkflowCount"
            label="会员最大流程数"
            width="120px"
          ></el-table-column>
          <el-table-column
            prop="vipSuit"
            label="当前套餐"
            width="120px"
            :formatter="formatterSuit"
          ></el-table-column> -->
          <el-table-column
            prop="exts.isTemplate"
            label="是否作为模板"
            :formatter="formatIsTemplate"
            width="120px"
            v-if="entity._id == '0'"
          ></el-table-column>
          <el-table-column
            prop="exts.isRecommend"
            label="是否置顶推荐模板"
            v-if="entity._id == '0'"
            :formatter="formatIsRecommend"
            width="120px"
          ></el-table-column>
          <el-table-column prop="state" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.state == 1">已启用</el-tag>
              <el-tag type="danger" v-else-if="scope.row.state == 0">已禁用</el-tag>
              <el-tag type="success" v-else>scope.row.state</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column fixed="right" width="100px" v-if="osg.has('Tenant,column')">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)" v-if="osg.has('Tenant,edit')">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doEnable(scope.row._id)"
                    v-if="scope.row.state == 0 && osg.has('Tenant,enable')"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doDisable(scope.row._id)"
                    v-if="scope.row.state == 1 && osg.has('Tenant,disable')"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="handleReview(scope.row)"
                    v-if="osg.has('Tenant,remove')"
                  >
                    删除
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doReset(scope.row._id)"
                    v-if="osg.has('Tenant,resetPassword')"
                  >
                    密码重置
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="editTemplate(scope.row)"
                    v-if="osg.has('Tenant,setTemplate')"
                  >
                    模板配置
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="getLog(scope.row)" v-if="osg.has('Tenant,log')">
                    操作日志
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="doClone(scope.row)"
                    v-if="osg.has('Tenant,clone')"
                  >
                    一键复制
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    @click="openUpgrade(scope.row)"
                    v-if="!scope.row.parentTenantId"
                  >
                    升级
                  </el-dropdown-item>
                  <el-dropdown-item @click="undoUpgrade(scope.row)" v-if="scope.row.parentTenantId">
                    撤回升级
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click="
                      billingFormData = {};
                      billingOpenDetail = true;
                      billingFormData.tenantId = scope.row._id;
                    "
                  >
                    购买新套餐
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="租户信息" :visible.sync="openDetail" width="500px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="110px"
        label-position="left"
      >
        <el-form-item label="编号" prop="code">
          <el-input v-model="formData.code"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="formData.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="{
            required: true,
            message: '请输入邮箱'
          }"
        >
          <el-input v-model="formData.email" placeholder="将作为登录账号"></el-input>
        </el-form-item>
        <!--<el-form-item
            label="密码"
            v-if="!edit"
            :prop="edit ? null : 'passwd'"
          >
            <el-input
              v-model="formData.passwd"
              show-password
              placeholder="请输入至少6位密码"
            ></el-input>
        </el-form-item>-->
        <el-form-item label="地址">
          <el-input v-model="formData.address"></el-input>
        </el-form-item>
        <!-- <el-form-item label="等级">
          <el-input v-model="formData.level"></el-input>
        </el-form-item> -->
        <el-form-item label="角色">
          <el-select v-model="formData.roles" multiple clearable>
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="租户信息" :visible.sync="openClone" width="500px">
      <el-form
        :model="cloneFormData"
        ref="cloneFormData"
        :rules="rules"
        label-width="110px"
        label-position="left"
      >
        <el-form-item label="编号" prop="code">
          <el-input v-model="cloneFormData.code"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="cloneFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="cloneFormData.phone" placeholder="将作为登录账号"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="{ required: true, trigger: 'blur', message: '邮箱不能为空' }"
        >
          <el-input v-model="cloneFormData.email"></el-input>
        </el-form-item>
        <!--<el-form-item
            label="密码"
            v-if="!edit"
            :prop="edit ? null : 'passwd'"
          >
            <el-input
              v-model="formData.passwd"
              show-password
              placeholder="请输入至少6位密码"
            ></el-input>
        </el-form-item>-->
        <el-form-item label="地址">
          <el-input v-model="cloneFormData.address"></el-input>
        </el-form-item>
        <!-- <el-form-item label="等级">
          <el-input v-model="cloneFormData.level"></el-input>
        </el-form-item> -->
        <el-form-item label="角色">
          <el-select v-model="cloneFormData.roles" multiple clearable>
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="clone">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="升级后迁移此租户下用户将登录目标租户使用,此租户禁用"
      :visible.sync="openEditUpgrade"
      width="500px"
    >
      <el-steps
        :active="stepsActive"
        finish-status="success"
        style="width: 100%; margin-bottom: 40px; margin-top: 15px"
      >
        <el-step title="选择租户"></el-step>
        <el-step title="选择租户下的组织"></el-step>
      </el-steps>
      <el-form
        :model="upgradeData"
        label-width="100px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="升级到的租户" prop="targetTenantId" v-show="stepsActive == 0">
          <el-select
            v-model="upgradeData.targetTenantId"
            placeholder="请选择要升级到的租户"
            clearable
            filterable
          >
            <el-option
              v-for="item in allTenant"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="targetOrgId"
          label="所属组织"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '组织不能为空'
          }"
          v-show="stepsActive == 1"
        >
          <el-cascader
            :options="treeData"
            placeholder="可搜索组织名称"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            filterable
            clearable
            v-model="upgradeData.targetOrgId"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="stepsBack" v-if="stepsActive == 1">上一步</el-button>
        <div v-else></div>
        <el-button type="primary" v-if="stepsActive == 0" @click="stepsNext()">下一步</el-button>
        <el-button v-else type="primary" @click="upgrade()">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="套餐详情" :visible.sync="billingOpenDetail">
      <el-form
        :model="billingFormData"
        :rules="rules"
        ref="billingFormData"
        label-width="120px"
        label-position="left"
      >
        <el-form-item label="选择套餐">
          <el-select v-model="billingFormData.vipSuit">
            <el-option
              v-for="item in options.vipSuit"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-show="item.value != '0'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-input v-model="billingFormData.payState"></el-input>
        </el-form-item>
        <el-form-item label="原价钱">
          <el-input v-model="billingFormData.price"></el-input>
        </el-form-item>
        <el-form-item label="价钱">
          <el-input v-model="billingFormData.origionPrice"></el-input>
        </el-form-item>
        <el-form-item label="选择开始日期">
          <el-date-picker
            v-model="billingFormData.vipStartDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="选择截至日期">
          <el-date-picker
            v-model="billingFormData.vipEndDate"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="会员截止日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="会员最大用户数">
          <el-input v-model="billingFormData.vipMaxUserCout"></el-input>
        </el-form-item>
        <el-form-item label="会员最大流程数">
          <el-input v-model="billingFormData.vipMaxWorkflowCount"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSaveBilling">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="模板配置" :visible.sync="openTemplate" width="900px">
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="110px"
        label-position="left"
      >
        <el-form-item label="租户名称">
          <span>{{ formData.name }}</span>
        </el-form-item>
        <el-form-item
          label="是否作为模板"
          prop="exts.isTemplate"
          :rules="{ required: true, trigger: 'change', message: '请选择是否作为模板' }"
        >
          <el-radio-group v-model="formData.exts.isTemplate" class="c-flex">
            <el-radio label="1">
              模板
            </el-radio>
            <el-radio label="0">
              非模板
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="是否置顶推荐"
          prop="exts.isRecommend"
          :rules="{ required: true, trigger: 'blur', message: '请选择是否推荐' }"
        >
          <el-radio-group v-model="formData.exts.isRecommend" class="c-flex">
            <el-radio label="1">
              置顶推荐
            </el-radio>
            <el-radio label="0">
              不置顶
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="模板标题"
          prop="exts.title"
          :rules="{ required: true, trigger: 'blur', message: '请填写模板标题' }"
        >
          <el-input v-model="formData.exts.title"></el-input>
        </el-form-item>
        <el-form-item
          label="场景"
          prop="scene"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '请选择适用场景'
          }"
        >
          <el-select v-model="formData.scene" multiple clearable>
            <el-option
              v-for="item in options.scene"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="行业"
          prop="trade"
          :rules="{ required: true, trigger: 'blur', message: '请选择所属行业' }"
        >
          <el-select v-model="formData.trade" multiple clearable>
            <el-option
              v-for="item in options.trade"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="exts.desc"
          :rules="{ required: true, trigger: 'blur', message: '请填写描述内容' }"
        >
          <el-input v-model="formData.exts.desc" type="textarea"></el-input>
        </el-form-item>
        <el-form-item
          label="头图"
          prop="exts.banner"
          :rules="{
            type: 'array',
            required: false,
            trigger: ['change', 'blur'],
            message: '请上传头图'
          }"
        >
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="formData.exts.banner"
            list-type="picture-card"
            :limit="1"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                return osg.uploadSuccess(response, file, fileList, 'formData.exts.banner');
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return osg.beforeRemove(file, fileList, 'formData.exts.banner');
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
            <img width="100%" :src="upload.dialogImageUrl" />
          </el-dialog>
        </el-form-item>
        <el-form-item
          v-if="formData.exts.isRecommend == '1'"
          label="置顶推荐背景颜色"
          prop="exts.color"
        >
          <el-color-picker
            v-model="formData.exts.bgcolor"
            show-alpha
            :predefine="predefineColors"
          ></el-color-picker>
        </el-form-item>
        <el-form-item
          label="内容"
          prop="exts.content"
          :rules="{ required: true, trigger: 'blur', message: '请编辑内容' }"
        >
          <c-editor :formData="formData" :value="'exts.content'" ref="editor"></c-editor>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="(log.row.name || '') + '-操作日志'" :visible.sync="log.show" width="800px">
      <div class="c-flex" style="margin:0 0 10px">
        <el-date-picker
          v-model="log.searchDate"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            log.fpi.page = 1;
            getLog();
          "
          style="width:50%"
        ></el-date-picker>
        <el-input
          placeholder="请输入要查询的内容"
          v-model="log.searchValue"
          clearable
          style="width:50%"
          @clear="
            log.fpi.page = 1;
            getLog();
          "
          @keyup.enter.native="
            log.fpi.page = 1;
            getLog();
          "
          class="c-m-l-10"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              log.fpi.page = 1;
              getLog();
            "
          ></el-button>
        </el-input>
      </div>
      <div class="content-table c-flex c-flex-col">
        <el-table
          ref="logtable"
          :data="log.fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
        >
          <el-table-column
            prop="createUserName"
            label="名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="uaccount"
            label="账号"
            min-width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="memo" label="操作" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="操作时间" min-width="140px"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="log.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="log.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="log.fpi.total"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'tenant',
  data() {
    return {
      fpi: {},
      searchValue: '',
      openDetail: false,
      openClone: false,
      openTemplate: false,
      log: { row: {}, searchDate: [], searchValue: '', fpi: { data: [] }, show: false },
      formData: {
        vipState: 0,
        vipType: 0,
        vipSuit: 0,
        exts: { banner: [] }
      },
      cloneFormData: {
        vipState: 0,
        vipType: 0,
        vipSuit: 0,
        exts: {}
      },
      rules: this.$util.rules,
      isEdit: false,
      isCloneEdit: false,
      options: {
        codecfg_vipState: { codeId: 'VIPSTATE' },
        codecfg_vipType: { codeId: 'VIPTYPE' },
        codecfg_vipSuit: { codeId: 'VIPSUIT' },
        codecfg_trade: { codeId: 'trade' },
        codecfg_scene: { codeId: 'scene' },
        roles: [],
        trade: [],
        scene: []
      },
      billingFormData: {}, //租户计费表单
      billingOpenDetail: false,
      entity: {},
      upgradeData: {
        shopTenantId: '',
        targetTenantId: '',
        targetOrgId: ''
      },
      allTenant: [],
      stepsActive: 0,
      openEditUpgrade: false,
      treeData: [], //所有组织
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      predefineColors: [
        '#2d7ff9',
        '#F82B68',
        '#666',
        '#ff6f2c',
        '#18bfff',
        '#fcb400',
        '#fee2d5',
        '#8b46ff',
        '#20c933'
      ],
      origin: window.location.origin
    };
  },
  mounted() {
    window.$this = this;
    this.entity = JSON.parse(sessionStorage.getItem('entity'));
    this.doInit();
    this.osg.ajax(
      'biz/extField/query.do',
      {
        colName: 'account',
        _all: '1',
        'is:state|integer#and': 1,
        'nin:preset|array-integer#and': 1,
        sortField: 'order',
        sortOrder: 'desc'
      },
      res => {
        this.extFields = res.data;
        this.options = this.options || {};
        for (var item of res.data) {
          if (item.valueOption) {
            this.options['codecfg_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
        }
        this.osg.codeoption(() => {
          this.osg.getFpi();
          this.getData();
          this.getRoles();
        });
      },
      { noload: true }
    );
  },
  methods: {
    formatIsTemplate(row, column, cellValue) {
      return cellValue == '1' ? '模板' : '';
    },
    formatIsRecommend(row, column, cellValue) {
      return cellValue == '1' ? '推荐' : '';
    },
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    pageSizeChange(pageSize) {
      if (this.log.show) {
        this.log.fpi.rows = pageSize;
        this.getLog();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.log.show) {
        this.log.fpi.page = currentPage;
        this.getLog();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    doInit() {
      this.openDetail = false;
      this.openClone = false;
      this.openTemplate = false;
      this.billingOpenDetail = false;
      this.formData = { exts: {} };
      this.cloneFormData = { exts: {} };
      this.billingFormData = {};
      this.openEditUpgrade = false;
      this.allTenant = [];
      this.treeData = [];
      this.upgradeData = {};
      this.stepsActive = 0;
      if (this.$refs.formData) this.$refs.formData.resetFields();
      if (this.$refs.cloneFormData) this.$refs.cloneFormData.resetFields();
      if (this.$refs.billingFormData) this.$refs.billingFormData.resetFields();
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        sortField: 'createTime',
        sortOrder: 'asc',
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:email|string#or': this.searchValue
      };
      if (this.entity.accountType == 'agency') {
        params['is:agencyId|string#and'] = this.entity.agencyId;
      }
      this.osg.setFpi(params);
      this.osg.ajax('tenant/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doEnable(id) {
      this.osg.ajax('tenant/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('tenant/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doReset(id) {
      this.osg.ajax('tenant/upsertAccount/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doNew() {
      this.doInit();
      this.isEdit = false;
      this.openDetail = true;
    },
    doEdit(row) {
      // if (row.agencyId) {
      //   this.doCloneEdit(row);
      //   return;
      // }
      row.exts = row.exts || {};
      row.exts.isTemplate = row.exts.isTemplate || null;
      row.exts.isRecommend = row.exts.isRecommend || null;
      this.formData = row;
      this.isEdit = true;
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        if (!this.isEdit) {
          this.formData.vipState = 1;
          this.formData.vipType = 0;
          this.formData.vipEndDate = this.AfterMonth();
          this.formData.vipMaxUserCout = 5;
          this.formData.vipMaxWorkflowCount = 5;
          this.formData.vipSuit = 0;
        }

        let params = this.$util.deepCopy(this.formData);
        // 图片数组转字符串
        if (params.exts.banner && this.$util.isJson(params.exts.banner)) {
          params.exts.banner = JSON.parse(params.exts.banner);
        }
        if (params.exts.banner && params.exts.banner.length > 0) {
          for (let item of params.exts.banner) {
            if (item.url.indexOf('blob:') != -1) {
              item.url = this.upload.downloadUrl + item.response.key;
            }
          }
          params.exts.banner = JSON.stringify(params.exts.banner);
        }

        this.osg.ajax('tenant/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doCloneEdit(row) {
      // 避免undefined复制后无法编辑
      row.email = row.email || '';
      row.address = row.address || '';
      row.level = row.level || '';
      // 表单数据赋值
      row.exts = row.exts || {};
      this.cloneFormData = this.$util.deepCopy(row);
      this.isCloneEdit = true;
      this.openClone = true;
    },
    doClone(row) {
      // 避免undefined复制后无法编辑
      row.email = row.email || '';
      row.address = row.address || '';
      row.level = row.level || '';
      // 复制全部表单数据
      this.cloneFormData = this.$util.deepCopy(row);
      // 清空复制后的需要填写的表单数据
      this.cloneFormData.code = '';
      this.cloneFormData.name = '';
      this.cloneFormData.phone = '';
      this.cloneFormData.email = '';
      this.cloneFormData.address = '';
      this.cloneFormData.level = '';
      // 复制要删除_id
      delete this.cloneFormData._id;
      this.isCloneEdit = true;
      this.openClone = true;
    },
    clone() {
      if (this.osg.validate('cloneFormData')) {
        if (!this.isCloneEdit) {
          this.cloneFormData.vipState = 1;
          this.cloneFormData.vipType = 0;
          this.cloneFormData.vipEndDate = this.AfterMonth();
          this.cloneFormData.vipMaxUserCout = 5;
          this.cloneFormData.vipMaxWorkflowCount = 5;
          this.cloneFormData.vipSuit = 0;
        }

        this.osg.ajax('tenant/cloneShopTenant.do', this.cloneFormData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    openUpgrade(row) {
      this.doInit();
      var params = {
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax('tenant/query.do', params, res => {
        this.allTenant = res.data;
      });
      this.openEditUpgrade = true;
      this.upgradeData.shopTenantId = row._id;
    },
    upgrade() {
      let data = this.upgradeData;
      console.log('收集到的升级信息是================' + JSON.stringify(data));
      this.osg.ajax(
        'tenant/upgradeShopTenant.do',
        {
          shopTenantId: data.shopTenantId,
          targetTenantId: data.targetTenantId,
          targetOrgId: data.targetOrgId
        },
        () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        }
      );
    },
    handleReview(row) {
      let myRow = this.$util.deepCopy(row);
      this.$prompt('！此操作将删除当前租户所有数据，请输入校验密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '你倒是输入点啥啊',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(({ value }) => {
        let tenantId = myRow._id;
        this.osg.ajax('tenant/deleteTenant.do', { password: value, tenantId: tenantId }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('删除成功');
        });
      });
    },
    undoUpgrade(row) {
      let myRow = this.$util.deepCopy(row);
      this.$prompt(
        '此操作将取消当前租户之前的升级操作,已经升级到的租户将禁用,此租户重新被激活!',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '你倒是输入点啥啊',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      ).then(({ value }) => {
        let tenantId = myRow._id;
        this.osg.ajax('tenant/undoUpgrade.do', { password: value, tenantId: tenantId }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('取消升级成功!');
        });
      });
    },
    formatterState(row, column, cellValue) {
      return this.osg.codelabel('vipState', cellValue);
    },
    formatterType(row, column, cellValue) {
      return this.osg.codelabel('vipType', cellValue);
    },
    formatterSuit(row, column, cellValue) {
      return this.osg.codelabel('vipSuit', cellValue);
    },
    //升级套餐
    doUpgrade(row) {
      this.billingFormData = JSON.parse(JSON.stringify(row));
      this.billingFormData.vipSuit = String(this.billingFormData.vipSuit);
      this.billingFormData.parentTransactionId = row._id;
      this.billingFormData.tenantId = row._id;
      delete this.billingFormData.name;
      delete this.billingFormData.code;
      delete this.billingFormData.phone;
      delete this.billingFormData.email;
      delete this.billingFormData.address;
      this.billingOpenDetail = true;
    },
    stepsBack() {
      if (this.stepsActive-- < 1) this.stepsActive = 0;
    },
    async stepsNext() {
      let tId = this.upgradeData.targetTenantId;
      this.treeData = [];
      if (!tId) {
        this.osg.toast('请选择要升级到的租户！', 'warning');
        return;
      }
      this.osg.ajax('org/queryForAdmin.do', { tenantId: tId }, res => {
        this.allOrg = res.data;
        this.treeData.push(this.allOrg);
      });
      this.stepsActive++;
    },
    //保存套餐
    doSaveBilling() {
      delete this.billingFormData.createTime;
      delete this.billingFormData.updateTime;
      let that = this;
      this.osg.ajax('basic/tenantTransaction/upsert.do', that.billingFormData, () => {
        this.osg.toast('保存成功！');
        this.getData();
        this.doInit();
      });
    },
    //获取三十天后日期
    AfterMonth() {
      var date1 = new Date();
      var date2 = new Date(date1);
      date2.setDate(date1.getDate() + 30);
      return (
        date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' 00:00:00'
      );
    },
    //获取所有角色
    getRoles() {
      this.osg.ajax('role/query.do', { _all: '1', 'is:state|integer#and': 1, type: 'c' }, res => {
        this.options.roles = res.data;
      });
    },
    editTemplate(row) {
      row.exts = row.exts || {};
      // 图片字符串转数组
      if (row.exts.banner && this.$util.isJson(row.exts.banner)) {
        row.exts.banner = JSON.parse(row.exts.banner);
      }
      this.formData = row;
      this.openTemplate = true;
      this.$nextTick(() => {
        this.$refs.formData.clearValidate();
      });
    },
    // 查看操作日志
    getLog(row) {
      if (row) {
        this.log = { row: row, searchDate: [], searchValue: '', fpi: { data: [] }, show: false };
      } else {
        this.log.row = this.log.row || {};
        this.log.searchDate = this.log.searchDate || [];
      }
      this.osg.ajax(
        'oplog/query.do',
        {
          'is:state|integer#and': 1,
          page: this.log.fpi.page,
          rows: this.log.fpi.rows,
          'regex:createUserName|string#or': this.log.searchValue,
          'regex:uaccount|string#or': this.log.searchValue,
          'regex:memo|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          tenantId: this.log.row._id
        },
        res => {
          this.log.fpi = res;
          this.log.show = true;
          this.$nextTick(() => {
            this.$refs.logtable.doLayout();
            this.$forceUpdate();
          });
        }
      );
    }
  }
};
</script>
<style>
.tenant .el-dialog__body {
  padding: 20px !important;
  display: flex;
  flex-direction: column;
}
</style>
